module.exports = __webpack_public_path__ + "static/img/active7.480aac19.png";